import React, { useEffect,  useRef, useState} from 'react';
import {Checkbox, message, Radio,} from 'antd';
import { SDrawer, SGeneralForms } from 'shj-components';
import { trimObj } from "@/utils/data.ts";
import { getEnums } from '@/services/homeService';
import TextArea from 'antd/es/input/TextArea';
import {httpDictServ} from '@/services/customerServices';
import {evaluationIndexSave, evaluationIndexUpdateById, getRoleList} from '@/services/evaluateConfig';
import {isArray} from "lodash-es";
import styles from "../../index.module.less";
import dayjs from "dayjs";
const Add = (props: any) => {
    const formRef = useRef<any>()
    const { visibleDrawer = false, title = '新增', closeDetails, reloadList,record } = props
    const [loading, setLoading] = useState(false);

    const temList = ['one','two','three','four','five','six','seven','eight','nine','ten']//后端定义写死的提交字段
    const [metricsCategoryEnumList, setMetricsCategoryEnumList] = useState([])//指标维度
    const [starList,setStarList] = useState([])//星级列表
    const [tagObj,setTagObj] = useState({})//改变中标签
    const [metricsCategory,setMetricsCategory] = useState('')//指标维度选中
    const [metricsCategoryName,setMetricsCategoryName] = useState('')//指标维度选中
    useEffect(() => {
        if (visibleDrawer) {
            // 重置
            formRef?.current?.onFormRef()?.resetFields();
            setStarList([...generateTemList()])
            initFn();
        }
    }, [visibleDrawer,record]);

    const generateTemList = () => {
        const list = [];
        temList.forEach((key, index) => {
            list.push({
                starIndex: index + 1,
                key: `${key}Star`,
                labelKey: `${key}StarLabel`,
                checkedValue: [],
                tagList: []
            });
        })
        return list;
    };
    const initFn = async () => {
        if (record?.id) {
            setLoading(true)
            try {
                const list:any = generateTemList()?.map((item) => {
                    const {labelKey} = item;
                    item.checkedValue = isArray(record[labelKey]) ? record[labelKey] : [];
                    item.tagList = isArray(record[labelKey]) ? record[labelKey] : [];
                    return item;
                });
                setStarList(list);
                formRef?.current?.onFormRef()?.setFieldsValue({...record});
                // 表单默认值
                await httpDictServ({ parentKey: record?.evaluationServiceType, enable: 1, }).then((res: any) => {
                    formRef.current?.updateState({
                        evaluationDimension:res
                    });
                })
            }catch (error){
                console.log(error)
            }finally {
                setLoading(false)
            }
            setLoading(false)
        }
    }
    const onSubmit = (values) => {
        let formObj = {
            ...values,
            metricsCategory,
            metricsCategoryName,
            status: true
        }
        formObj = trimObj(formObj, 'trim');
        // 验证数组还有编辑状态
        const isEdit = starList.some((item:any)=>{return item.isEdit});
        if(isEdit){
            return message.error('请先保存标签');
        }
        // 处理数据
        starList.forEach((item)=>{
            formObj[item.key] = item.starIndex;
            formObj[item.labelKey] = item.checkedValue;
        })
        if(record?.id){
            formObj.id = record?.id||""
        }
        setLoading(true);
        const urlApi = record?.id ? evaluationIndexUpdateById : evaluationIndexSave;
        urlApi({
            ...formObj
        }).then((res) => {
            setLoading(false)
            message.success(res.message || "操作成功")
            reloadList()
            closeDetails()
        }).catch(() => {
            setLoading(false)
        })
    };
    const getOptions = async (): Promise<any> => {
        // 评价类别枚举
        const evaluationCategoryEnumList: any = await getEnums("plus-member", "com.shj.saas.plus.member.enums.EvaluationCategoryEnum")
        const evaluationCategoryEnum = evaluationCategoryEnumList.filter(item => item.description != '订单评价')
        // 服务类型列表
        const evaluationServiceTypeList: any = await httpDictServ({ parentKey: 'evaluationServiceType', enable: 1, });
        // 查询角色列表
        const roleList: any = await getRoleList(
            {
                "roleType": "SYSTEM",  //只查内置角色
                "enabled": true   //启用的
            }
        );
        // 指标维度列表
        const metricsCategoryEnumList: any = await getEnums("plus-member", "com.shj.saas.plus.member.enums.MetricsCategoryEnum")
        setMetricsCategoryEnumList(metricsCategoryEnumList);
        // 设置默认值
        if(isArray(metricsCategoryEnumList)&&metricsCategoryEnumList.length>0){
            setMetricsCategory(record?.metricsCategory||metricsCategoryEnumList[0].key);
            setMetricsCategoryName(record?.metricsCategoryName||metricsCategoryEnumList[0].description)
        }
        return Promise.resolve({
            evaluationCategoryEnum,
            evaluationServiceTypeList,
            roleList,
        });
    }
    // 改变数组
    const changeStarEdit = (index,key,value) => {
        const list:any = [...starList];
        list[index][key] = value;
        setStarList(list)
    }
    const starItemRender = (item,index) => {
        return (
            <div className={styles.starItemBox} key={index}>
                <div className={styles.title}>{item?.starIndex}星</div>
                {
                    item.isEdit ? <>
                            <div className={styles.textAreaBox}>
                                <TextArea
                                    style={{width:'100%'}}
                                    maxLength={300}
                                    autoSize
                                    placeholder="请输入备注"
                                    value={tagObj[index]||""}
                                    onChange={(e) => {
                                        const obj = {...tagObj};
                                        obj[index] = `${e?.target?.value || ""}`.trim();
                                        setTagObj(obj)
                                    }}
                                />
                            </div>
                            <div className={styles.starItemBtn}>
                                <div
                                    className={styles.saveBtn}
                                    onClick={() => {
                                        // 保存默认选中全部标签
                                        if(tagObj[index]){
                                            const list = tagObj[index]?.split('、')?.filter(element => element.trim()!=='');
                                            changeStarEdit(index,'tagList',list)
                                            changeStarEdit(index,'checkedValue',list)
                                        }
                                        changeStarEdit(index,'isEdit',!starList[index]?.isEdit)
                                    }}
                                >保存</div>
                                <div onClick={() => {changeStarEdit(index,'isEdit',!starList[index]?.isEdit)}}>取消</div>
                            </div>
                        </>
                        : <div className={styles.starItem}>
                            <div className={styles.checkedBox}>
                                {item.tagList?.map((it, i) => {
                                    return <span key={i}  className={styles.checkedItem}>
                                    <Checkbox
                                        key={index} checked={item?.checkedValue?.includes(it)}
                                        onChange={()=>{
                                          let list = [...item.checkedValue];
                                          if(item?.checkedValue.includes(it)){
                                              list = list.filter(val => val != it)
                                          }else{
                                              list.push(it)
                                          }
                                          changeStarEdit(index,'checkedValue',list)
                                        }}
                                    >{it}</Checkbox >
                                </span>
                                })}
                                <span
                                    className={styles.saveBtn}
                                    onClick={() => {
                                        changeStarEdit(index,'isEdit',!starList[index].isEdit)
                                        const obj = {...tagObj};
                                        obj[index] = starList[index]?.tagList?.join('、');
                                        setTagObj(obj)
                                    }}
                                >编辑</span>
                            </div>
                        </div>
                }
            </div>
        )
    }

    const configs: any = [
        {
            title: '',
            titleMode: 'drawer',
            formItem: [
                {
                    name: 'evaluationServiceType',
                    label: '服务类型',
                    required: true,
                    spanCol: 8,
                    data: 'evaluationServiceTypeList',
                    type: 'select',
                    comConfig: {
                        fieldNames: { label: 'name', value: 'priKey' },
                        onChange: (_v, o) => {
                            // 不是人员评价时、改变清空评价维度
                            if(formRef?.current?.onFormRef()?.getFieldValue('evaluationCategory') !== 'userEvaluation'){
                                formRef?.current?.onFormRef()?.setFieldValue('evaluationDimension', "");
                            }
                            httpDictServ({ parentKey: o['priKey'], enable: 1, }).then((res: any) => {
                                formRef.current?.updateState({
                                    evaluationDimension:res
                                });
                            })
                        }
                    }
                },
                {
                    name: 'evaluationCategory',
                    label: '评价类别',
                    required: true,
                    spanCol: 8,
                    data: 'evaluationCategoryEnum',
                    type: 'select',
                    comConfig: {
                        fieldNames: { label: 'description', value: 'key' },
                        onChange: () => {
                            // 改变清空评价维度
                            formRef?.current?.onFormRef()?.setFieldValue('evaluationDimension', "");
                        }
                    }
                },
                {
                    name: 'evaluationDimension',
                    label: '评价对象',
                    required: true,
                    spanCol: 8,
                    isDeps: true,
                    deps: form => form.getFieldValue('evaluationCategory')!=='userEvaluation',
                    data:"evaluationDimension",
                    type: 'select',
                    comConfig: {
                        fieldNames: { label: 'name', value: 'priKey' },
                    },
                },
                {
                    name: 'evaluationDimension',//评价类别为人员
                    label: '评价对象',
                    required: true,
                    spanCol: 8,
                    isDeps: true,
                    deps: form => form.getFieldValue('evaluationCategory')==='userEvaluation',
                    data:"roleList",
                    type: 'select',
                    comConfig: {
                        fieldNames: { label: 'name', value: 'code' },
                    }
                },
                {
                    label: '指标维度',
                    required: true,
                    spanCol: 24,
                    children: (
                        <>
                            {
                                isArray(metricsCategoryEnumList)&&metricsCategoryEnumList?.length>0?<Radio.Group
                                    value={metricsCategory}
                                    onChange={(e) => {
                                        const val = e?.target?.value||"";
                                        const label = metricsCategoryEnumList.filter((it: any) => it.key === val)[0]?.description;
                                        setMetricsCategory(val)
                                        setMetricsCategoryName(label)
                                    }}
                                >
                                    {
                                        metricsCategoryEnumList.map((item: any,i) => {
                                            return <Radio.Button key={i} value={item.key}>{item.description}</Radio.Button>
                                        })
                                    }
                                </Radio.Group>:null
                            }
                        </>
                    ),
                },
                {
                    spanCol: 24,
                    children: (
                        <div className={styles.starListBox}>
                            {
                                isArray(starList)&&starList?.length>0? <>
                                    {
                                        starList.map((item: any, index: number) => {
                                            return starItemRender(item,index)
                                        })
                                    }
                                </>:null
                            }
                        </div>
                    )
                },
            ],
        }
    ]
    return (
        <>
            <SDrawer
                width={1000}
                title={record?.id?'编辑':'新增'}
                open={visibleDrawer}
                onClose={closeDetails}
                onSubmit={onSubmit}
                loading={loading}
                destroyOnClose
            >
                <SGeneralForms
                    ref={formRef}
                    layout="vertical"
                    httpOptionsFn={getOptions}
                    configs={configs}
                />
            </SDrawer>
        </>
    );
};
export default Add
